export default __webpack_public_path__ + "static/media/IF_MyStrengths_StrengthDesc_04.230178f6.jpg";